
const newTaskTransformer = response => {
  let requiredKeys = ["token_payment", "contact_client_call", "follow_up_call", "meeting_done", "meeting_arrange", "partial_down_payment", "complete_down_payment", "closed_won"]
  return (response.filter(arr => requiredKeys.find(key => key === arr.key)))
}

export default newTaskTransformer
